module.exports = __webpack_public_path__ + "static/img/store-bg-2.815746b8.png";